export default "__VITE_ASSET__DEB$3764__"